import { render, staticRenderFns } from "./RecordCheckContent.vue?vue&type=template&id=05184ea3&scoped=true&"
import script from "./RecordCheckContent.vue?vue&type=script&lang=js&"
export * from "./RecordCheckContent.vue?vue&type=script&lang=js&"
import style0 from "./RecordCheckContent.vue?vue&type=style&index=0&id=05184ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05184ea3",
  null
  
)

component.options.__file = "RecordCheckContent.vue"
export default component.exports